import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: {
      title: '冷丰生态 - 官方网站'
    }
  },
  {
    path: '/products/:productKey',
    name: 'product-detail',
    component: () => import('../views/ProductDetail.vue'),
    meta: {
      title: '产品详情 - 冷丰生态'
    }
  },
  {
    path: '/download',
    name: 'download-center',
    component: () => import('../views/DownloadCenter.vue'),
    meta: {
      title: '下载中心 - 冷丰生态'
    }
  },
  {
    path: '/download/:appKey',
    name: 'download-detail',
    component: () => import('../views/DownloadDetail.vue'),
    meta: {
      title: 'App 下载 - 冷丰生态'
    }
  },
  // 丰营宝更名为丰银宝，旧链接继续可用
  { path: '/products/fengyingbao', redirect: '/products/fengyinbao' },
  { path: '/download/fengyingbao', redirect: '/download/fengyinbao' },
  // 旧协议链接默认落到冷丰渠道，避免外部收藏失效
  { path: '/legal/user-agreement', redirect: '/legal/lengfeng/user-agreement' },
  { path: '/legal/privacy-policy', redirect: '/legal/lengfeng/privacy-policy' },
  {
    path: '/legal/:appKey/:documentKey',
    name: 'legal',
    component: () => import('../views/LegalPage.vue'),
    meta: {
      title: '法律文档 - 冷丰生态'
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to) {
    if (to.hash) {
      return {
        el: to.hash,
        top: 84,
        behavior: 'smooth'
      }
    }
    return { top: 0 }
  }
})

router.afterEach((to) => {
  document.title = to.meta.title || '冷丰生态 - 官方网站'
})

export default router
